import useBreakpointHook from "use-breakpoint";

// 프로젝트 기준 브레이크포인트 설정
const BREAKPOINTS = {
  mobile: 0,
  tablet: 800,
  pc: 1281,
  // largePc: 1920,
} as const;

export function useBreakpoint() {
  const { breakpoint } = useBreakpointHook(BREAKPOINTS, "mobile");

  return {
    breakpoint,
    isMobile: breakpoint === "mobile",
    isTablet: breakpoint === "tablet",
    isPc: breakpoint === "pc",
    // isLargePc: breakpoint === "largePc",
  };
}
